import {RefObject, useContext} from 'react';
import classNames from "classnames";
import {StoreContext} from "../../../stores/StoreLoader";
import {toggleBlockLock} from "./blockUtils";
import WatsonApi from "../../../backends/WatsonApi";

export default function BlockHoverButtons(props: {
    blockObj: AnyBlockObj,
    blockRef: RefObject<HTMLDivElement>,
    hidden: boolean,
    packeryInstance: any,
    hasMicrosite: boolean,
}) {
    const {
        gridStore,
        modalStore,
        sidebarStore,
        organizationStore,
    } = useContext(StoreContext);
    const {blockObj, blockRef, hidden} = props;

    const childLocked = blockObj?.blockComponent?.reusedBlockComponent?.settings.display.childLocked;
    const contentItemBlock = blockObj.blockType === "content_item";

    const lockButtonClassNames = classNames(
        'sb-button', 'sb-tool-icon', 'sb-lock-icon', 'sb-hidden-xs', 'sb-hidden-sm', 'sb-hidden-md',
        {
            "sb-hidden-lg": props.hasMicrosite,
            'hidden': hidden || contentItemBlock,
            'sb-cannot-move-icon': childLocked,
        },
    );
    const lockButtonIconClassNames = classNames(
        'fa',
        {
            'fa-lock': blockObj.positionLocked,
            'fa-unlock-alt': !blockObj.positionLocked,
        }
    );
    const moveButtonClassNames = classNames(
        'sb-button', 'sb-tool-icon', 'sb-move-icon', 'sb-hidden-xs', 'sb-hidden-sm', 'sb-hidden-md',
        {
            'hidden': hidden || contentItemBlock,
            'sb-cannot-move-icon': blockObj.positionLocked,
        },
    );
    const editButtonClassNames = classNames(
        'sb-button', 'sb-tool-icon', 'sb-edit-icon',
        {
            'hidden': hidden,
        },
    );

    const oppositeLockStateLabel = blockObj.positionLocked ? 'unlock' : 'lock';

    const onLockClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        toggleBlockLock(gridStore, props.packeryInstance, blockRef.current)
    };

    const onMoveClick = (e) => {
        // Do nothing because we don't want to register the click...it's a drag handle
        e.stopPropagation();
        e.preventDefault();
    };

    const onEditClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const blockType = blockObj.blockType;

        modalStore.addModal({
            type: "addOrEditBlock",
            blockType,
            blockObj,
            intent: "edit",
        })
    };

    const editSFFullPage = async (e) => {
        e.stopPropagation();
        await sidebarStore.setSidebar({
            view: "SchoolFeedPost",
            contentItem: blockObj.blockModel,
            handleSave: async (contentItem, organization) => {
                const result = await organizationStore.fetchClient("organizations", "organizations_content_items_partial_update", {
                    organization_pk: contentItem.organization_id,
                    id: blockObj.id,
                    data: contentItem,
                });
                const item = result.obj;
                const block = gridStore.blocks.get(item.id);
                block.title = item.title;
                block.blockModel.title = item.title;
                block.description = item.description;
                block.blockModel.description = item.description
                block.json_data = item.json_data;
                block.blockModel.json_data = item.json_data;
            },
            handleDelete: async (contentItem) => {
                const client = await WatsonApi();
                await client.apis.organizations.organizations_content_items_delete({
                    id: contentItem.id,
                    organization_pk: contentItem.organization_id,
                });
                gridStore.blocks.delete(contentItem.id);
            }
        })
    }

    return <>
        <button key="lock" type="button" onClick={onLockClick}
                className={lockButtonClassNames}
                disabled={childLocked}
                title={`Click to ${oppositeLockStateLabel} the size and position`}
                aria-label={`Click to ${oppositeLockStateLabel} the size and position`}
        >
            <span className={lockButtonIconClassNames} role="presentation"/>
        </button>
        <button key="move" type="button" onClick={onMoveClick}
                className={moveButtonClassNames}
                title="Use this button to drag the block around the grid"
                aria-label="Use this button to drag the block around the grid"
                disabled={blockObj.positionLocked}
        >
            <span className="fas fa-arrows-alt" role="presentation"/>
        </button>
        <button key="edit" type="button" onClick={contentItemBlock ? editSFFullPage : onEditClick}
                className={editButtonClassNames} title="Click to edit"
                aria-label="Click to edit">
            <span className="fas fa-pencil-alt" role="presentation"/>
        </button>
    </>
}
